import { Box, makeStyles } from "@material-ui/core";
import { useBreakpoint } from "../hooks/useBreakpoint";
import { color } from "../app/theme";

type TopBoxProps = {
  hiddenButton?: boolean;
  bgColor: string;
  boxHeight?: string;
  outsideBgColor: string;
};

export const TopBox = ({ hiddenButton, bgColor, outsideBgColor, boxHeight }: TopBoxProps) => {
  const { isMoreThanMd } = useBreakpoint();
  const classes = useStyles({ bgColor, outsideBgColor, isMoreThanMd, boxHeight })();

  return (
    <Box width="100%" position="relative">
      {!hiddenButton && (
        <Box
          width={54}
          height={54}
          bgcolor={color.orange}
          position="absolute"
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={2}
          className={classes.topButton}
        >
          <img loading="lazy" src={"images/arrow_down.svg"} alt="arrow_down" />
        </Box>
      )}
      <Box className={classes.customBox} />
    </Box>
  );
};

const useStyles = ({
  bgColor,
  outsideBgColor,
  isMoreThanMd,
  boxHeight
}: {
  bgColor?: string;
  outsideBgColor?: string;
  isMoreThanMd: boolean;
  boxHeight?: string;
}) =>
  makeStyles({
    customBox: {
      "overflow": "hidden",
      "position": "relative",
      "height": boxHeight ?? "calc(100% + 2px)",
      "background": outsideBgColor,
      "&::after": {
        content: "''",
        background: bgColor,
        width: "122%",
        height: !isMoreThanMd ? "200%" : "400%",
        position: "absolute",
        left: 0,
        transform: "translateX(-9%)",
        borderRadius: "50%"
      }
    },
    topButton: {
      transform: "translate(-50%, -50%)",
      left: "50%",
      cursor: "pointer"
    }
  });
